function setPlaceholderText() {
if(window.innerWidth > 1007) {
    $('.e2ma_signup_form_element #id_email').attr('placeholder', 'Add Your Email Address');
}
else {
    $('.e2ma_signup_form_element #id_email').attr('placeholder', 'Your Email');  
}
}


window.addEventListener('resize', function(event) {
    setPlaceholderText();
}, true);


document.addEventListener("DOMContentLoaded", (event) => {
    setPlaceholderText();
    $('#e2ma_signup_submit_button').parent().prepend(`
    <label for="e2ma_signup_submit_button">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M-4.37114e-07 11L20 11M20 11L10 1M20 11L10 21" stroke="#0B231D" stroke-width="2"/>
        </svg>
    </label>
    `);
  });

var currentURL = new URL(window.location.href);
document.addEventListener("DOMContentLoaded", (event) => {

if (currentURL.searchParams.has('success')) {
  let successMessage = $('.franchise-newsletter').data('successmessage');
  let innerHtmlContainer = $('.franchise-newsletter-inner');
  innerHtmlContainer.addClass('form-success');
  innerHtmlContainer.append(`
    <div class="messageSuccess">
    ${successMessage}
    </div>
  `);


window.addEventListener("load", (event) => {


  setTimeout(() => {
  document.getElementById('franchiseNewsletter').scrollIntoView();
}, 200);
});
  
}
});




window.addEventListener("load", (event) => {
$('#id_sms_phone_number').attr('placeholder', 'Phone Number');
$('.sms-field #id_email').attr('placeholder', 'Email Address');

$('#e2ma_signup [type="email"]').on( "keyup", function() {

  var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

  if (reg.test($('#e2ma_signup [type="email"]').val()) == false)  {
    $('[for="e2ma_signup_submit_button"]').removeClass('validated');
    return false;
  }
  else {
    $('[for="e2ma_signup_submit_button"]').addClass('validated');
  }

  return true;
});
  
let smsField = $('[name="sms_phone_number"]');
$(smsField).get(0).type = 'tel';
$(smsField).attr('pattern','[0-9]{10}');
$(smsField).parent().addClass('sms-row');
$(smsField).parent().append('<div class="info-hover"></div>');
$('.info-hover').attr('data-tooltip','Input your 10-digit phone number without any special characters (IE, 0123456789)');
//$(smsField).parent().append('<span class="phone-validation">Input your 10-digit phone number without any special characters (IE, 0123456789) </span>');

});
